export const login = "/login";

export const restore = "/restore";

export const changePassword = "/change-password/:username/:token"
